import { useEffect, useState } from "react"

const AddNamaazInput = ({labelVal, inputValueHander}) => {

    const[iVal, setIval] = useState(0)

    const setIValHandler = (_v) => {
        setIval(_v)
    }

    const increaseIVal = (e) => {
        setIval((_v)=>{
            return _v+1
        })
    }

    const decreaseIVal = (e) => {
        setIval((_v)=>{
            return _v-1
        })
    }

    useEffect(()=>{
        inputValueHander(iVal)
    },[iVal])

    return <>
        <label>{labelVal}</label>
        <span style={{display:'inline-block', width:'20px', paddingLeft: '10px', paddingRight: '5px'}}><button onClick={decreaseIVal}>-</button></span>
        <input
          type="number"
          value={iVal}
          onChange={(e) => setIValHandler(e.target.value)}
          className="border p-2"
        />
        <span style={{display:'inline-block', width:'10px', paddingLeft:'5px'}}><button onClick={increaseIVal}>+</button></span>
    </>
}

export default AddNamaazInput